import { ImagesEntity } from '@galabid/gb-dashboard/shared/data-access-images'

export interface WidgetPagesEntity extends OldWidgetsEntity {
  widget_buttons: WidgetPageButton[]
  tablet_view: WidgetPageMobileViewEnum
  mobile_view: WidgetPageMobileViewEnum
}

export interface OldWidgetsEntity {
  uuid: string
  created: string
  updated: string
  auction: string
  is_visible: boolean
  name: string
  background_color: string | null
  background_image: ImagesEntity | null
  rows: number
  columns: number
}

export enum WidgetPageMobileViewEnum {
  Desktop = 'desktop',
  TwoColumn = 'two_column',
  OneColumn = 'one_column',
}

// TODO: update to use PascalCase for enum keys
export enum WidgetPageButtonTypeEnum {
  ITEM = 'item',
  CATEGORY = 'category',
  URL_LINK = 'url_link',
  BASIC = 'basic',
  INFO_BOOTH = 'infobooth',
  WIDGET_PAGE = 'widget_page',
  TICKETING = 'ticketing',
  ITEM_TYPE = 'item_type',
}

export enum TicketingLinkEnum {
  SingleTicket = 'single',
  AllTickets = 'all_tickets',
}

export interface WidgetPageButton {
  uuid: string
  created: string
  updated: string
  row: string
  x: number
  y: number
  width: number
  height: number
  background_color: string
  text_color: string
  button_type: WidgetPageButtonTypeEnum
  item: string | null
  category: string | null
  widget_page_link: string | null
  url_link: string | null
  url_link_new_tab: boolean
  background_image: ImagesEntity | null
  text: string
  infobooth: string | null
  item_image: string | null
  widget_page: string
  item_type: string | null
  ticketing_link: TicketingLinkEnum
  single_ticket: string | null
}

export const WIDGET_PAGES_LOADER = {
  deleteWidgetPage: {
    id: 'deleteWidgetPage',
    message: 'WIDGETS.DELETING_WIDGET_PAGE',
  },
}
